var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_c('iq-card', {
    attrs: {
      "body-class": "p-0"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function fn() {
        return [_c('div', {
          staticClass: "iq-edit-list"
        }, [_c('tab-nav', {
          staticClass: "iq-edit-profile d-flex",
          attrs: {
            "pills": true
          }
        }, [_c('tab-nav-items', {
          staticClass: "col-md-6 p-0",
          attrs: {
            "active": true,
            "href": "#planning",
            "title": "SHIPMENT PLANNING"
          },
          on: {
            "click": function click($event) {
              _vm.activeTab = 'planning';
            }
          }
        }), _c('tab-nav-items', {
          staticClass: "col-md-6 p-0",
          attrs: {
            "active": false,
            "href": "#realisasi",
            "title": "RUNNING SHIPMENT"
          },
          on: {
            "click": function click($event) {
              _vm.activeTab = 'realisasi';
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }])
  })], 1), _c('b-col', {
    attrs: {
      "lg": "12"
    }
  }, [_vm.activeTab == 'planning' ? [_c('TabShipmentPlanningNew')] : _vm._e(), _vm.activeTab == 'realisasi' ? [_c('TabRunningShipment')] : _vm._e(), _vm.activeTab == 'report' ? [_c('TabReport')] : _vm._e()], 2)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }